<template>
  <app-base-main :baseStyle="{height: '100%', boxSizing: 'border-box', background: 'none', paddingTop: '12px'}" :contentStyle="{height: '100%'}">
    <template #base-content>
      <app-left-right-stow show-stow-button @change="stowChange">
        <template #left>
          <app-sp-ad-tree
              ref="spAdTree"
              :init-market-id="marketId"
              @market-change="marketChange($event)"
              @portfolio-change="portfolioChange($event)"
              @getLocal="getLocal"
              @goHome="goHome"
          ></app-sp-ad-tree>
        </template>
        <template #right>
          <div class="ad-tree__market" v-show="!isStow">
            <gj-market-select
                init-value
                width="200px"
                :value="marketId"
                :clearable="false"
                @input="rightMarketChange($event)"
            ></gj-market-select>
            <div class="ad-tree--time">
              <gj-local-time :label="localCountry" :time="localTime"></gj-local-time>
            </div>
          </div>
          <div v-if="adStore.SP.isAdsAuth" class="right-content">
            <app-sp-ad-navigator></app-sp-ad-navigator>
            <template v-if="showAdManager">
              <app-sp-ad-manager
                  ref="adSpManager"
                  :init-date="adStore.SP.campaignDate"
                  :market-id="marketId"
                  :portfolio-id="portfolioId"
                  :active-tab="activeTab"
              ></app-sp-ad-manager>
            </template>
            <template v-else-if="showCampaignManager">
              <app-sp-ad-campaign-manager
                  :market-id="marketId"
                  :portfolio-id="portfolioId"
                  :campaign-id="adStore.SP.campaign.campaignId"
                  :active-tab="activeTab"
                  :init-date="adStore.SP.campaignDate"
              ></app-sp-ad-campaign-manager>
            </template>
            <template v-else-if="showGroupManager">
              <app-sp-ad-group-manager
                  :market-id="marketId"
                  :portfolio-id="portfolioId"
                  :campaign-id="adStore.SP.campaign.campaignId"
                  :group-id="adStore.SP.group.groupId"
                  :active-tab="activeTab"
                  :group-targeting-type="groupTargetingType"
                  :init-date="adStore.SP.groupDate"
              ></app-sp-ad-group-manager>
            </template>
          </div>
          <div v-else class="no-auth-wrapper">
            <div class="no-auth-empty">
              <gj-empty text="未进行广告授权，请先授权"></gj-empty>
              <gj-button
                  type="primary"
                  @click="$router.push('/system/market')">
                广告授权
              </gj-button>
            </div>
          </div>
        </template>
      </app-left-right-stow>
    </template>
  </app-base-main>
</template>

<script>
  import AppSpAdTree from "./ad-tree/ad-tree";
  import {adStore} from "../common/store";
  import AppSpAdNavigator from "./common/components/ad-navigator";
  import AppSpAdManager from "./ad-manager/ad-manager";
  import AppSpAdCampaignManager from "./ad-campaign-manager/ad-campaign-manager";
  import AppSpAdGroupManager from "./ad-group-manager/ad-group-manager";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../utils/common";
  import { Common } from '@/api/ad.js'
  import {mapGetters} from "vuex";
  import { AdDefaultBid } from "@/views/modules/ad/common/enum";

  export default {
    name: "app-sp-ad",
    components: {AppSpAdGroupManager, AppSpAdCampaignManager, AppSpAdManager, AppSpAdNavigator, AppSpAdTree},
    created() {
      if (isMeaningful(this.$route.query.marketId)) {
        this.marketId = this.$route.query.marketId;
      }
      if (isMeaningful(this.$route.query.campaignId)) {
        this.adStore.SP.campaign = {
          campaignId: this.$route.query.campaignId,
          campaignName: this.$route.query.campaignName,
        };
      }
      if (isMeaningful(this.$route.query.groupId)) {
        this.adStore.SP.group = {
          groupId: this.$route.query.groupId,
          groupName: this.$route.query.groupName,
        };
      }
      this.activeTab = defaultVal(this.$route.query.activeTab, null);
      this.groupTargetingType = defaultVal(this.$route.query.groupTargetingType, null);
    },
    mounted() {
      adStore.SP.rootMountEl = this.$el;
    },
    data() {
      return {
        adStore: adStore,
        marketId: null,
        portfolioId: null,
        activeTab: null,
        targetingType: null,
        groupTargetingType: null,
        localCountry: null,
        localTime: null,
        isStow: true,
      cornerMarker: {}, // 角标对象
      }
    },
    provide() {
      return {
        getCornerMark: this.getCornerMark,
        cornerMarkerMap: () => this.cornerMarker
      }
    },
    computed: {
      ...mapGetters({
        markets: 'authMarkets'
      }),
      showAdManager() {
        return isMeaningless(this.adStore.SP.campaign) && isMeaningless(this.adStore.SP.group);
      },
      showCampaignManager() {
        return isMeaningful(this.adStore.SP.campaign) && isMeaningless(this.adStore.SP.group);
      },
      showGroupManager() {
        return isMeaningful(this.adStore.SP.campaign) && isMeaningful(this.adStore.SP.group);
      },
    },
    methods: {
      // 回到首页
      goHome() {
        this.$refs.adSpManager && (this.$refs.adSpManager.activeTabMap = "adCampaign")
      },
    // 获取角标
    async getCornerMark() {
      let params = {
        marketId: this.marketId,
        campaignId: this.adStore.SP.campaign && (this.adStore.SP.campaign.campaignId || this.adStore.SP.campaign.draftsCampaignId),
        groupId: this.adStore.SP.group && this.adStore.SP.group.groupId,
        portfolioId: this.portfolioId,
        adsType: 0
      }
      let { data } = await Common.getCornerMark(params)
      this.cornerMarker = data
    },
      marketChange(marketId) {
        if (this.marketId !== marketId) {
          //店铺变化时 根据店铺所属国家，获取默认竞价
          this.adStore.SP.defaultBid = AdDefaultBid[this.markets.find(r => r.id === marketId).countryCode]?.SPDefaultBid || null;
          this.marketId = marketId;
          this.adStore.SP.campaign = null;
          this.adStore.SP.group = null;
        }
      },
      portfolioChange(portfolioId) {
        if (this.portfolioId !== portfolioId) {
          this.portfolioId = portfolioId;
          this.adStore.SP.campaign = null;
          this.adStore.SP.group = null;
        }
      },
      // 左侧店铺修改
      rightMarketChange(marketId) {
        this.$refs.spAdTree.marketChange(marketId)
      },
      // 获取站点事件名称
      getLocal(localTime, localCountry) {
        this.localTime = localTime
        this.localCountry = localCountry
      },
      // 左右结构展开收起
      stowChange(type) {
        this.isStow = type
        // this.$store.dispatch("ad/setTableHeight")
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common/no-auth";
  /deep/ .right-container{
    display: flex;
    flex-direction: column;
  }
  .right-content {
    height: 0;
    flex: 1;
    padding: 0 16px 16px 16px;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    /deep/.ad-tabs {
      height: 0;
      flex: 1;
    }
  }
  /deep/ .right-container-bg{
    padding-top: 4px;
    height: calc(100% - 20px);
  }
  .ad-tree__market {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 16px 16px 0;
    /deep/.el-input__inner {
      background: #F6F8FB;
      border: 0;
      &:focus{
        box-shadow: none;
      }
    }
    .ad-tree--time {
      padding-left: 16px;
      /deep/.gj-local-time {
        color: #999;
      }
    }
  }
</style>
